import { queryOptions, useQuery } from '@tanstack/react-query';

import { policiesApi } from '../api/policies-api';

import { policyKeys } from './policy-keys';

export function policyQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: policyKeys.detail(storeId, id),
    queryFn: () => policiesApi.get(storeId, id),
  });
}

export function usePolicy(storeId: string, id: string) {
  return useQuery(policyQueryOptions(storeId, id));
}
